export default function helperTextNemo(nemoInput: string, selectedNemo: string) {
  if (nemoInput === "" || nemoInput === " ") {
    return "Escribe y selecciona un instrumento del listado"
  }
  if (nemoInput !== selectedNemo) {
    return "Selecciona un instrumento del listado"
  }
  return " "
}
